<nav class="sidebar">
  <div class="sidebar-header">

    <!--- Logo -->
    <a routerLink="/" class="sidebar-brand nobleui-logo">
      Empower<span>GO</span>
    </a>

    <!-- <a routerLink="/" class="sidebar-brand nobleui-logo">
    <img src="assets/images/logo.png" alt="logo">
  </a> -->

  <!--- Toggler -->
  <div class="sidebar-toggler not-active" #sidebarToggler (click)="toggleSidebar($event)">
    <span></span>
    <span></span>
    <span></span>
  </div>

</div>
<div class="sidebar-body" (mouseenter)="operSidebarFolded()" (mouseleave)="closeSidebarFolded()" [perfectScrollbar]>

  <!--- Sidemenu start -->

  <ul class="sidebar-nav metismenu" id="sidebar-menu" #sidebarMenu>
    @for (item of menuItems; track item) {
      @if (roleModuleList?.includes(item.role)) {
        <div>
          @if (item.isTitle) {
            <li class="nav-item nav-category">{{ item.label  | translate }}</li>
          }
          @if (!item.isTitle) {
            <li class="nav-item">
              @if (hasItems(item)) {
                <a class="nav-link" href="javascript:void(0);">
                  @if (item.icon) {
                    <i class="link-icon" [attr.data-feather]="item.icon" appFeatherIcon></i>
                  }
                  <span class="link-title"> {{ item.label  | translate }}</span>
                  <span class="link-arrow" data-feather="chevron-down" appFeatherIcon></span>
                </a>
              }
              @if (!hasItems(item)) {
                <a class="nav-link nav-link-ref" [routerLink]="item.link"
                  [attr.data-parent]="item.parentId">
                  @if (item.icon) {
                    <i class="link-icon" [attr.data-feather]="item.icon" appFeatherIcon></i>
                  }
                  <span class="link-title"> {{ item.label  | translate }}</span>
                  @if (item.badge) {
                    <span class="badge bg-{{item.badge.variant}}">{{item.badge.text}}</span>
                  }
                </a>
              }
              @if (hasItems(item)) {
                <ul class="sidebar-nav sub-menu nav-second-level" aria-expanded="false">
                  @for (subitem of item.subItems; track subitem) {
                    <li class="nav-item" [ngClass]="{'side-nav-item': hasItems(subitem)}">
                      @if (hasItems(subitem)) {
                        <a class="nav-link side-nav-link-a-ref" href="javascript:void(0);">
                          @if (subitem.icon) {
                            <i class="link-icon" [attr.data-feather]="subitem.icon" appFeatherIcon></i>
                          }
                          <span class="link-title"> {{ subitem.label | translate }}</span>
                          <span class="link-arrow" data-feather="chevron-down" appFeatherIcon></span>
                        </a>
                      }
                      @if (!hasItems(subitem)) {
                        <a class="nav-link nav-link-ref" [routerLink]="subitem.link"
                          [attr.data-parent]="subitem.parentId">
                          @if (subitem.icon) {
                            <i class="link-icon" [attr.data-feather]="subitem.icon" appFeatherIcon></i>
                          }
                          {{ subitem.label | translate }}
                        </a>
                      }
                      @if (hasItems(subitem)) {
                        <ul class="sidebar-nav sub-menu nav-third-level" aria-expanded="false">
                          @for (subSubitem of subitem.subItems; track subSubitem) {
                            <li class="nav-item">
                              <a class="nav-link nav-link-ref" [routerLink]="subSubitem.link" [routerLinkActive]="['active']"
                                [attr.data-parent]="subSubitem.parentId">
                                @if (subitem.icon) {
                                  <i class="link-icon" [attr.data-feather]="subitem.icon" appFeatherIcon></i>
                                }
                                {{ subSubitem.label | translate }}
                              </a>
                            </li>
                          }
                        </ul>
                      }
                    </li>
                  }
                </ul>
              }
            </li>
          }
        </div>
      }
    }
  </ul>

  <!--- Sidemenu end -->

</div>
</nav>